import { render, staticRenderFns } from "./TemplateSelectModal.vue?vue&type=template&id=2ac1641b&scoped=true&"
import script from "./TemplateSelectModal.vue?vue&type=script&lang=js&"
export * from "./TemplateSelectModal.vue?vue&type=script&lang=js&"
import style0 from "./TemplateSelectModal.vue?vue&type=style&index=0&id=2ac1641b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac1641b",
  null
  
)

export default component.exports